var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckmarkFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 0A2.5 2.5 0 0 1 24 2.5v19a2.5 2.5 0 0 1-2.5 2.5h-19A2.5 2.5 0 0 1 0 21.5v-19A2.5 2.5 0 0 1 2.5 0h19Zm-1.548 5.84a1.5 1.5 0 0 0-2.111.208l-7.206 8.779-3.624-3.304-.12-.098A1.5 1.5 0 0 0 4.99 13.74l4.793 4.369.116.095a1.5 1.5 0 0 0 2.054-.252l8.207-10 .092-.124a1.5 1.5 0 0 0-.3-1.987Z",
    fillRule: "nonzero"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckmarkFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checkmark-filled.307ba0abf06137497e6f5bca90402023.svg";